import { FormControlLabel, Switch } from '@material-ui/core';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { ContainerLeft, ContainerLeftHeader } from 'components/common/styles';
import SearchBarDialect from 'components/search/SearchBarDialect';
import { useForceRender } from 'hooks/useForceRender';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import MemoryListModel from '../../../models/MemoryListModel';
import TranslationEditModal from '../../../components/translation/TranslationEditModal';
import { ITranslation } from '../../../types/Translation';
import { IGridData } from '../../../types/models';

export type IProps = {
  search?: string;
  dialect?: string;
};

const MemoryMain: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const [editTranslationId, setEditTranslationID] = useState<number | null>(null);
  const [searchType, setSearchType] = useState<'memory' | 'regular'>('memory');

  const model = useMemo(() => new MemoryListModel({ render: forceRender }), [forceRender]);

  useEffect(() => {
    if (props.search && props.dialect) {
      setEditTranslationID(null);
      setSearchType('memory');
      model.setSearchType('memory');
      model.getGridSearch(props.search, props.dialect, 'memory');
    }
  }, [props.search, props.dialect]);

  const handleSearchTypeChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newSearchType = event.target.checked ? 'regular' : 'memory';
      setSearchType(newSearchType);
      model.setSearchType(newSearchType);
    },
    [model],
  );

  const handleCloseModal = useCallback(() => {
    setEditTranslationID(null);
  }, []);

  const handleUpdate = useCallback((translationId: number, dialects: ITranslation[]) => {
    setEditTranslationID(null);
    model.update(translationId);
  }, []);

  const handleRowClick = useCallback((row: IGridData) => {
    setEditTranslationID(row.id);
  }, []);

  return (
    <>
      <ModuleContext.Provider value={model}>
        <ContainerLeft>
          <ContainerLeftHeader>
            <SearchRow>
              <FormControlLabel
                control={
                  <Switch
                    checked={searchType === 'regular'}
                    onChange={handleSearchTypeChange}
                    color="primary"
                    size="small"
                  />
                }
                label={searchType === 'regular' ? 'Regular' : 'Memory'}
              />
              <SearchBarDialectStyled onlyTarget searchText={props.search} searchDialectId={props.dialect} />
            </SearchRow>
          </ContainerLeftHeader>
          <Grid handleRowClick={handleRowClick} />
        </ContainerLeft>
      </ModuleContext.Provider>
      {editTranslationId && (
        <TranslationEditModal onClose={handleCloseModal} translationId={editTranslationId} onUpdated={handleUpdate} />
      )}
    </>
  );
};

const SearchRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const SearchBarDialectStyled = styled(SearchBarDialect)`
  flex: 1;
`;

export default MemoryMain;
